// js
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import OverlapPercentageAnalysisArea from './OverlapPercentageAnalysisArea';
// css
import '../../styles/components/analytics/OverlapPercentageAnalysis.scss';


class OverlapPercentageAnalysis extends Component {

  getPercentOverlap(area) {
    const { stats, selectedArea } = this.props;
    return stats[selectedArea.id][area.id].overlapPercent;
  }

  renderAreas() {
    const { areas, selectedArea } = this.props;
    const otherAreas = areas.filter(a => a.id !== selectedArea.id);
    return otherAreas.map((area, index) => this.renderArea(area, index));
  }

  renderArea(area, index) {
    const overlap = this.props.stats[this.props.selectedArea.id][area.id];

    return (
      <OverlapPercentageAnalysisArea
        key={index}
        areaTitle={area.title}
        disabled={!this.props.isAreaEnabled(area)}
        totalData={overlap.totalIndexed}
        percent={this.getPercentOverlap(area)}
        dataSourcesCount={overlap.overlapItems}
        totalDataSourcesCount={overlap.areaItems}
        ciscoDataIndexed={overlap.ciscoDataIndexed}
        nonCiscoDataIndexed={overlap.nonCiscoDataIndexed}
      />
    );
  }

  render() {
    return (
      <div className='analytics__overlap-percentage-analysis'>
        <h6 className='analytics__overlap-title'>Percentage of Overlap</h6>
        <ul>
          {this.renderAreas()}
        </ul>
      </div>
    );
  }
}

OverlapPercentageAnalysis.propTypes = {
  stats: PropTypes.object.isRequired,
  selectedArea: PropTypes.object.isRequired,
  areas: PropTypes.array.isRequired,
  isAreaEnabled: PropTypes.func.isRequired
};

export default OverlapPercentageAnalysis;



// WEBPACK FOOTER //
// ./src/components/analytics/OverlapPercentageAnalysis.js